import { icon } from "../functions/icons";

export function IconAtom({icon2,onClick, style, iconSize, color="var(--standard-text-color)"}){
    return(
        <div onClick={(event) =>{ event.stopPropagation();onClick();}} data-testid='icon-atom' className={`${color} icon-atom`} style={{ ...style }}>    
            {icon(icon2, iconSize,color)}
        </div>
    )
}
export function IconAtom2({ color,icon2, style, iconSize, onClick}){
    return(
        <div onClick={onClick ? (event) =>{ event.stopPropagation();onClick()}: console.log('')} data-testid='icon-atom' className={`${color}`}>
            <div style={style} className="small-standard-padding primary-background-100 round">
            {icon(icon2, iconSize)}
            </div>
        </div>
    )
}


